import React from "react";
import "./Quotes.scss";
import flower from "../../assets/flower.svg";

function Quotes1() {
  return (
    <section className="quote">
      <img
        className="flower quote__flower"
        src={flower}
        alt="Roberto Coin logo"
      ></img>
      <p className="quote__copy quote1__copy--desktop">
        “Italy is the best, most wonderful theater in the world—an open-air
        theater where everybody can decide what role to play.”
      </p>

      <p className="quote__copy quote1__copy--mobile">
        “Italy is the best, most wonderful theater in the world—an open-air
        theater where everybody can decide what role to play.”
      </p>
    </section>
  );
}

export default Quotes1;
